export enum TimesheetAdditionalBonusType {
    Other = 'Other', // 0 - Other ("Inne")
    AdditionForExtraWork = 'AdditionForExtraWork', // 1 - AdditionForExtraWork ("Dodatek za pracę w godzinach nadliczbowych")
    AdditionForWorkAbroad = 'AdditionForWorkAbroad', // 2 - AdditionForWorkAbroad ("Dodatek za zlecenia zagraniczne")
    AdditionForWorkInCountry = 'AdditionForWorkInCountry', // 3 - AdditionForWorkInCountry ("Dodatek za zlecenia krajowe")
    ImportFromOneLocation = 'ImportFromOneLocation', // 4 - ImportFromOneLocation ("Dowóz z 1 miejsca")
    ImportFromMultipleLocation = 'ImportFromMultipleLocation', // 5 - ImportFromMultipleLocation ("Dowóz z kilku miejsc")
    ImportHeavyLoad = 'ImportHeavyLoad', // 6 - ImportHeavyLoad ("Ciężki gabaryt")
}
